import { usePutMutation } from "@/api/swr/useMutation";
import { interviewRecordUpdateSchema } from "@/schema/console/interview-records/InterviewRecord";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof interviewRecordUpdateSchema, z.ZodNull>
>[3];

export const useUpdateInterviewRecord = (id: string, config?: Config) => {
  return usePutMutation(
    interviewRecordUpdateSchema,
    z.null(),
    `/console/re_assessments/${id}/interview_record/`,
    config,
  );
};
